let $el = $('.js-notices');

$el.on('tippy:show', function () {
	
	let $noticeCount = $('.js-notices-count');
	
	if($noticeCount.length > 0) {
		
		$.ajax({
			url: '/notices/',
			method: 'get',
			dataType: "json",
			data: {
				'action': 'read_all',
			},
			success: function (data) {
				if (data.successful_request) {
					$('.js-notices-count').remove();
				}
			},
		});
		
	}
	
});